import { useRoutes } from 'react-router-dom'

import MainLayout from '../layouts/main'
import LoginPage from '../pages/Login'
import Page404 from '../pages/Page404'

import ProtectedRoute from '../components/auth/ProtectedRoute'
import PageError from '../pages/PageError'
import BasicInfo from '../pages/staff/BasicInfo'
import BlogDashboard from '../pages/staff/BlogDashboard'
import Payroll from '../pages/staff/Payroll'
import SalaryInfo from '../pages/staff/SalaryInfo'
import SubmitFormPage from '../pages/staff/SubmitFormPage'
import TimeSheet from '../pages/staff/TimeSheet'

export default function Router() {
  return useRoutes([
    // Dashboard Routes
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <MainLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: '/',
          element: <TimeSheet />
        },
        {
          path: 'staff-info',
          children: [
            { path: 'basic', element: <BasicInfo /> },
            { path: 'salary', element: <SalaryInfo /> }
          ]
        },
        {
          path: 'time-sheet',
          children: [
            { path: 'check', element: <TimeSheet /> },
            { path: 'submit', element: <SubmitFormPage /> },
            { path: 'blogs', element: <BlogDashboard /> }
          ]
        },
        { path: 'payroll', element: <Payroll /> }
      ]
    },

    {
      path: '/login',
      element: <LoginPage />
    },

    {
      path: '/error',
      element: <PageError />
    },

    { path: '*', element: <Page404 /> }
  ])
}
